import { Flagrp_Fla } from './fla_grp';
import { Flagent_cfg } from './flagent_cfg';
import { Fldr } from './fldr';
import { Org } from './org';
import { Flagent } from './flagent';
import { Fla_Fldr } from './fla_fldr';
import { CommonEnums } from '../../common.enums';

export class Flagent_Grp {
    flagent_Grp_Id: number;
    nm: string;

    flagents: Array<Flagent>;
    description: string;
    updateDt: Date;
    updateBy: string
    error_Cd: string;
    error_Msg: string;
    fla_Fldrs: Array<Fla_Fldr>;
    flagrp_Flas: Array<Flagrp_Fla>;
    fldrs: Array<Fldr>;
    org_Id: number;
    orgs: Array<Org>;
    org_Nm: string;
    imageUrl: string;

    constructor() {
        this.setDefaults();
    }

    setDefaults() {
        this.flagent_Grp_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.error_Cd = CommonEnums.defaults.ERROR_CD;
        this.error_Msg = CommonEnums.defaults.ERROR_MSG;
        this.flagrp_Flas = new Array<Flagrp_Fla>();
        this.fla_Fldrs = new Array<Fla_Fldr>();
        this.flagents = new Array<Flagent>();
        this.fldrs = new Array<Fldr>();
        this.org_Id = CommonEnums.defaults.DEFAULT_ORGANIZAION_ID;
        this.orgs = new Array<Org>();
        this.org_Nm = CommonEnums.defaults.DEFAULT_ORGANIZAION_NAME;
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(object: any): Flagent_Grp {   // Constant method that is the same for every instance of a class.
        let flagent_Grp: Flagent_Grp = new Flagent_Grp();
        flagent_Grp.copyFrom(object as Flagent_Grp);
        return flagent_Grp;
    }

    copy(): Flagent_Grp {
        let flagent_GrpTmp: Flagent_Grp = new Flagent_Grp();

        flagent_GrpTmp.flagent_Grp_Id = this.flagent_Grp_Id;
        flagent_GrpTmp.nm = this.nm;
        flagent_GrpTmp.flagents = this.flagents;
        flagent_GrpTmp.description = this.description;
        flagent_GrpTmp.updateDt = this.updateDt;
        flagent_GrpTmp.updateBy = this.updateBy;
        flagent_GrpTmp.error_Cd = this.error_Cd;
        flagent_GrpTmp.error_Msg = this.error_Msg;
        flagent_GrpTmp.fla_Fldrs = this.fla_Fldrs;
        flagent_GrpTmp.flagrp_Flas = this.flagrp_Flas;
        flagent_GrpTmp.fldrs = this.fldrs;
        flagent_GrpTmp.org_Id = this.org_Id;
        flagent_GrpTmp.orgs = this.orgs;
        flagent_GrpTmp.org_Nm = this.org_Nm;
        flagent_GrpTmp.imageUrl = this.imageUrl;

        return flagent_GrpTmp;
    }

    copyFrom(flagent_GrpTmp: Flagent_Grp): void {
        if (!flagent_GrpTmp) return;

        this.flagent_Grp_Id = flagent_GrpTmp.flagent_Grp_Id;
        this.nm = flagent_GrpTmp.nm;
        this.flagents = flagent_GrpTmp.flagents;
        this.description = flagent_GrpTmp.description;
        this.updateDt = flagent_GrpTmp.updateDt;
        this.updateBy = flagent_GrpTmp.updateBy;
        this.error_Cd = flagent_GrpTmp.error_Cd;
        this.error_Msg = flagent_GrpTmp.error_Msg;
        this.fla_Fldrs = flagent_GrpTmp.fla_Fldrs;
        this.flagrp_Flas = flagent_GrpTmp.flagrp_Flas;
        this.fldrs = flagent_GrpTmp.fldrs;
        this.org_Id = flagent_GrpTmp.org_Id;
        this.orgs = flagent_GrpTmp.orgs;
        this.org_Nm = flagent_GrpTmp.org_Nm;
        this.imageUrl = flagent_GrpTmp.imageUrl;
    }

    compare(flagent_GrpTmp: Flagent_Grp): string {
        let flagent_GrpString: string = this.toString(false);
        let flagent_GrpTmpString: string = flagent_GrpTmp.toString(false);

        if (flagent_GrpString != flagent_GrpTmpString) {
            return flagent_GrpString + ', ' + flagent_GrpTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Flagent_Grp [flagent_Grp_Id=" + this.flagent_Grp_Id + ", nm=" + this.nm +
            ", description=" + this.description +
            ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy +
            ",org_Id=" + this.org_Id;

        if (isNotCompare) {
            str += ", flagents=" + this.flagents +
                ", error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg +
                ", fla_Fldrs =" + this.fla_Fldrs + ", flagrp_Flas=" + this.flagrp_Flas +
                ", fldrs=" + this.fldrs + ", orgs=" + this.orgs +
                ", org_Nm=" + this.org_Nm + ", imageUrl=" + this.imageUrl;
        }

        str += ']';
        return str;

    }
}


